export default "/correct.1ef5f427-ac05c7.png";